module.exports = __webpack_public_path__ + "img/ring_r_e_1_null.eefdda28.png";